import React from "react";
import CustomTag from "./CustomTag";
import { FireOutlined } from "@ant-design/icons";
import FanDTO from "src/models/FanDTO";

interface BurnerStatusTagProps{

    fans: FanDTO[] | null | undefined;

}

const BurnerStatusTag : React.FC<BurnerStatusTagProps> = ({ fans }) => {

    const isBurnerOn = fans?.some(f => f.highFireOn === true || f.midFireOn === true || f.lowFireOn === true || f.isHeaterOn === true) ?? false;

    if(isBurnerOn){
        return(
            <CustomTag label={'Burner: ON'} icon={<FireOutlined />} color={"green"} />
        )
    }
    
    return(
        <CustomTag label={'Burner: OFF'} icon={<FireOutlined />} color={"red"} />
    )
}

export default BurnerStatusTag;
